import React, { useEffect, useRef, useState } from "react";
import {
  CaretDownFill,
  ChevronLeft,
  Grid,
  ListUl,
} from "react-bootstrap-icons";
import { Link, NavLink, useNavigate } from "react-router-dom";
import GetSvgIcon from "../assets/images/svgList";
import CommonModal from "../Components/Modals/CommonModal";
import { useSearchStore } from "../store/search/searchStore";
import Breadcrumb from "../Shared/BreadCrumb/Breadcrumb";
import useMenuStore from "../store/menu/useMenuStore";

interface pageHeaderFields {
  name: string;
  icon: React.ReactNode;
  functionality?: () => void;
}

interface pageHeaderProps {
  listUrl?: string;
  gridUrl?: string;
  addUrl?: string;
  name?: string;
  nameButtonStatus?: boolean;
  viewType?: boolean;
  isHistoryEnabled?: boolean;
  historyData?: React.ReactNode;
  isShowUpload?: boolean;
  handleGlobalSearch?: (data: string) => void;
  handleGlobalFilter?: () => void;
  isShowAllHeader?: boolean;
  isShowBackBtn?: boolean;
  isShowButtonDropdown?: boolean;
  dropDownData?: any;
  showBreadCrumb?: boolean;
  isDropdown?: boolean;
  onAddClick?: () => void;
  isModal?: boolean;
  heading?: string;
  content?: React.ReactNode;
  customClassName?: string;
  customClassNameForBody?: string;
  customClassNameForHeader?: string;
  footerButtonsActive?: boolean;
  modalSize?: string;
  setShowModalForImportAndExport?: any;
  showModalForImportAndExport?: any;
  hideAddButton?: boolean;
  filterDataCount?: any;
  isCustomBtn?: boolean;
  customBtn?: () => void;
  moreOptions?: [pageHeaderFields];
  show?: boolean;
  setShow?: (show: boolean) => void;
}

const PageHeader = (props: pageHeaderProps) => {
  const {
    listUrl = "",
    gridUrl = "",
    addUrl = "",
    name,
    nameButtonStatus = true,
    viewType = false,
    isHistoryEnabled = false,
    historyData,
    isShowUpload = true,
    handleGlobalSearch,
    isShowAllHeader = false,
    isShowBackBtn = false,
    isShowButtonDropdown = false,
    dropDownData = [],
    isDropdown,
    onAddClick,
    isModal = false,
    heading,
    content,
    setShowModalForImportAndExport,
    showModalForImportAndExport,
    customClassName,
    customClassNameForBody,
    footerButtonsActive,
    modalSize,
    customClassNameForHeader,
    moreOptions,
    hideAddButton = false,
    filterDataCount,
    isCustomBtn,
    customBtn,
    show = false,
    setShow,
  } = props;

  const { items, loading } = useMenuStore();
  const { searchTerm, setSearchTerm, resetSearch } = useSearchStore();
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const textInputRef = useRef<HTMLInputElement>(null);
  const [handleInput, setHandleInput] = useState<string>(searchTerm ?? "");
  const navigate = useNavigate();

  // Debounce effect to avoid rapid api call onkey
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);

    return () => clearTimeout(handler);
  }, [searchTerm]);

  useEffect(() => {
    if (handleGlobalSearch) {
      handleGlobalSearch(debouncedSearchTerm);
    }
  }, [debouncedSearchTerm, handleGlobalSearch]);

  const handleGlobalFilter = () => {
    if (props.handleGlobalFilter) {
      props.handleGlobalFilter();
    }
  };
  const handleOnEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSearchTerm();
    }
  };

  const handleShow = () => {
    if (setShow) {
      setShow(!show);
    }
  };
  const handleSearchTerm = () => {
    setSearchTerm(handleInput);
  };
  return (
    <>
      <div
        className={
          isShowAllHeader === false
            ? "d-flex justify-content-between align-items-center"
            : "d-flex align-items-center gap-5"
        }
      >
        <div>
          <Breadcrumb navigationData={items} />
        </div>
        <div className={isShowAllHeader === false ? "col-auto" : "col-6 ms-5"}>
          <div className="d-flex align-item-center pageHeaderItems">
            {!viewType && (
              <>
                {gridUrl !== "" ? (
                  <>
                    <div className="me-3 align-self-center toggle-grid border border-secondary-subtle rounded-pill">
                      <div className="btn-group grid-toggle">
                        <NavLink
                          to={listUrl}
                          className={({ isActive }) => {
                            let classNames = "";
                            if (isActive) {
                              classNames =
                                "d-block btn  btn-sm rounded-pill border-0 px-3 active";
                            } else {
                              classNames =
                                "d-block btn  btn-sm rounded-pill border-0 px-3";
                            }
                            return classNames; // returns "registerButton" or "registerButton active"
                          }}
                        >
                          <ListUl size={20} />
                        </NavLink>
                        <NavLink
                          to={gridUrl}
                          className={({ isActive }) => {
                            let classNames = "";
                            if (isActive) {
                              classNames =
                                "d-block btn  btn-sm rounded-pill border-0 px-3 active";
                            } else {
                              classNames =
                                "d-block btn  btn-sm rounded-pill border-0 px-3";
                            }
                            return classNames; // returns "registerButton" or "registerButton active"
                          }}
                        >
                          <Grid size={20} />
                        </NavLink>
                      </div>
                    </div>
                    <div className="me-3">
                      <div className="input-group rounded-pill col-auto">
                        <input
                          type="text"
                          className="form-control rounded-start-pill border border-end-0 pe-0 search-input"
                          placeholder="Search Here"
                          value={handleInput}
                          ref={textInputRef}
                          onChange={(e) => setHandleInput(e.target.value)}
                          onKeyDown={handleOnEnter}
                        />
                        <span
                          className="input-group-text bg-white border border-start-0 rounded-end-pill cursor-pointer"
                          onClick={handleSearchTerm}
                        >
                          {GetSvgIcon.GlobalSearchIcon}
                        </span>
                      </div>
                    </div>
                    <div className="cursor-pointer align-self-center">
                      {GetSvgIcon.GlobalFilter}
                    </div>

                    <div className="mx-3 align-self-center opacity-50">|</div>

                    <div className="cursor-pointer align-self-center">
                      {GetSvgIcon.GlobalUpArrow}
                    </div>

                    <div className="mx-3 align-self-center opacity-50">|</div>

                    <div className="cursor-pointer align-self-center">
                      {GetSvgIcon.GlobalDownArrow}
                    </div>
                  </>
                ) : (
                  <>
                    {isShowAllHeader === false ? (
                      <>
                        <div className="me-3">
                          <div className="input-group rounded-pill col-auto">
                            <input
                              type="text"
                              className="form-control rounded-start-pill border border-end-0 pe-0 search-input"
                              placeholder="Search Here"
                              value={handleInput}
                              ref={textInputRef}
                              onChange={(e) => setHandleInput(e.target.value)}
                              onKeyDown={handleOnEnter}
                            />
                            <span
                              className="input-group-text bg-white border border-start-0 rounded-end-pill cursor-pointer"
                              onClick={handleSearchTerm}
                            >
                              {GetSvgIcon.GlobalSearchIcon}
                            </span>
                          </div>
                        </div>
                        {filterDataCount > 0 ?
                          <div className="cursor-pointer align-self-center " onClick={handleGlobalFilter}>
                            {GetSvgIcon.GlobalFilter} 
                            <span className="filter-badge position-absolute translate-middle bg-primary text-white 
                            rounded-circle align-items-center justify-content-center 
                            fw-bold shadow" style={{width: "15px", height: "15px",fontSize: "10px",marginTop: "-2px", marginLeft: "2px",paddingLeft: "4px",}}>{filterDataCount}</span>
                          </div> :
                          <div className="cursor-pointer align-self-center" onClick={handleGlobalFilter}>
                            {GetSvgIcon.GlobalFilter}
                          </div>
                        }
                        <div className="mx-3 align-self-center opacity-50">
                          |
                        </div>

                        {isShowUpload === true ? (
                          <>
                            {" "}
                            <div
                              className="cursor-pointer align-self-center"
                              onClick={() =>
                                setShowModalForImportAndExport(
                                  (prevState: any) => ({
                                    ...prevState,
                                    importModal: false,
                                  })
                                )
                              }
                            >
                              {GetSvgIcon.GlobalUpArrow}
                            </div>
                            <div className="mx-3 align-self-center opacity-50">
                              |
                            </div>
                          </>
                        ) : (
                          ""
                        )}

                        <div
                          className="cursor-pointer align-self-center"
                          onClick={() =>
                            setShowModalForImportAndExport(
                              (prevState: any) => ({
                                ...prevState,
                                exportModal: false,
                              })
                            )
                          }
                        >
                          {GetSvgIcon.GlobalDownArrow}
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="me-3 w-100">
                          <div className="input-group rounded-pill col-auto">
                            <input
                              type="text"
                              className="form-control rounded-start-pill border border-end-0 pe-0  search-input"
                              placeholder="Search Here"
                              value={handleInput}
                              ref={textInputRef}
                              onChange={(e) => setHandleInput(e.target.value)}
                              onKeyDown={handleOnEnter}
                            />
                            <span
                              className="input-group-text bg-white border border-start-0 rounded-end-pill cursor-pointer"
                              onClick={handleSearchTerm}
                            >
                              {GetSvgIcon.GlobalSearchIcon}
                            </span>
                          </div>
                        </div>
                      </>
                    )}
                  </>
                )}
              </>
            )}
            {moreOptions &&
              moreOptions.map((e, i) => {
                return (
                  <>
                  <span className="mx-3 mt-1 opacity-50">|</span> 
                  <span className="mt-1 d-flex" onClick={e.functionality}>
                    {e.icon}
                  </span>
                  </>
                );
              })}

            {viewType === false ? (
              !isDropdown ? (
                !isModal ? (
                  !hideAddButton ? (
                    nameButtonStatus ? (
                      isShowBackBtn === false ? (
                        <button 
                          className="sph-btn ms-3 fs-14" 
                          onClick={() => {
                            onAddClick?.();
                            addUrl && navigate(addUrl);
                          }}
                        >
                          + {name}
                        </button>
                      ) : (
                        ""
                      )
                    ) : (
                      <button
                        className="sph-btn-disabled ms-3 fs-14"
                        disabled
                      >
                        + {name}
                      </button>
                    )
                  ) : (
                    <></>
                  )
                ) : (
                  <>
                    <button
                        className={`sph-btn-disabled ms-3 fs-14 ${nameButtonStatus ? 'sph-btn' : ''}`}
                        onClick={nameButtonStatus ? handleShow : () => {}}
                        disabled={!nameButtonStatus}
                    >
                        + {name}
                    </button>

                    {show && (
                      <CommonModal
                        handleClose={() => setShow?.(false)}
                        show={show}
                        heading={heading}
                        content={content}
                        modalSize={modalSize || "modal-lg"}
                        footerButtonsActive={footerButtonsActive}
                        customClassNameForBody={customClassNameForBody}
                        customClassNameForHeader={
                          customClassNameForHeader || "create-kit-orders"
                        }
                      />
                    )}
                  </>
                )
              ) : (
                // Dropdown Button
                <>
                  <button
                    className="sph-btn ms-3  fs-14 rounded"
                    type="button"
                    id="dropdownMenuButton"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <div className="d-flex align-items-center justify-content-center gap-1">
                      + {name}
                      <CaretDownFill style={{ fontSize: "10px" }} />
                    </div>
                  </button>
                  <ul
                    className="dropdown-menu "
                    aria-labelledby="dropdownMenuButton"
                  >
                    {dropDownData?.map((btnName: any, index: number) => (
                      <li key={index}>
                        <Link className="dropdown-item " to={btnName.link}>
                          <b className="fs-14 ">{btnName?.name}</b>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </>
              )
            ) : (
              <>
              {/*only for add btn history and back btn  */}
                {isCustomBtn === true ? (
                  <button
                    className="sph-btn sph-shift ms-3 fs-14"
                    onClick={customBtn}
                  >
                    {name}
                  </button>
                ) : (
                  ""
                )}
                {isHistoryEnabled === true && historyData}
                <Link
                  to={gridUrl !== "" ? gridUrl : listUrl}
                  className="col-auto d-flex align-items-center"
                >
                  {isShowBackBtn === false ? (
                    <span className="fw-medium text-secondary-emphasis d-flex align-items-center">
                      <span className="rounded-circle d-inline-block back-arrow">
                        {" "}
                        <ChevronLeft size={12} />
                      </span>{" "}
                      <span className="ms-1 fs-15">Back</span>
                    </span>
                  ) : (
                    ""
                  )}
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default PageHeader;
